export function isXhrError(err: any) {
  return err?.isAxiosError || Boolean(err?.response?.status);
}

export function getServiceName(url = '') {
  return url.split(/\/api\/([^/?\s]+)/g)?.[1] || undefined;
}
